import { Routes } from '@angular/router';

export const NoSidenavNoHeaderLayout_ROUTES: Routes = [

  {
    path: 'organisation',
    loadChildren: () => import('../../authentication/organizer/organizer.module').then(m => m.OrganizerModule),
  },

  {
    path: 'teams',
    loadChildren: () => import('../../authentication/TeamMember/team-member.module').then(m => m.TeamMemberModule),
  },

  {
    path: 'restaurant',
    loadChildren: () => import('../../authentication/restaurant/restaurant.module').then(m => m.RestaurantModule),
  },
]
